// Shared status/email-state derivation for the invoice action UI (row, detail
// dialog, and the grouped ⋯ menu they both use) — a single source of truth
// for the design_handoff_invoice_actions / design_handoff_invoice_detail
// state table, so the row and dialog can never drift out of sync.
export const getInvoiceActionState = (invoice) => {
  const status = invoice?.status;
  const isDraft = status === 'draft';
  const isIssued = status === 'issued';
  const isPaid = status === 'paid';
  const isVoid = status === 'void';
  const isProcessingIssue = status === 'processing_issue';
  const isProcessingPayment = status === 'processing_payment';
  const isProcessing = isProcessingIssue || isProcessingPayment;
  const hasEmailActivity = Boolean(invoice?.emailStatus) || Boolean(invoice?.emailSentAt)
    || (Array.isArray(invoice?.emailRecipients) && invoice.emailRecipients.length > 0);
  const isIssuedNotSent = isIssued && !hasEmailActivity;
  const isIssuedSent = isIssued && hasEmailActivity;
  const canDownloadPdf = !isDraft && !isProcessing;
  const canUseShippingLabel = invoice?.shippingLabelAvailable === true
    && ['issued', 'paid', 'void'].includes(status);

  return {
    isDraft, isIssued, isPaid, isVoid,
    isProcessingIssue, isProcessingPayment, isProcessing,
    hasEmailActivity, isIssuedNotSent, isIssuedSent,
    canDownloadPdf, canUseShippingLabel,
  };
};
